import { useState } from "react";

export type WeekLayout = "periods" | "calendar";
const KEY = "timetable-layout";

/** The week's layout, remembered per viewer: periods across (the school's printed form) or a calendar by clock time. */
export function useWeekLayout() {
  const [layout, setLayout] = useState<WeekLayout>(() => {
    try {
      return localStorage.getItem(KEY) === "calendar" ? "calendar" : "periods";
    } catch {
      return "periods";
    }
  });
  const choose = (next: WeekLayout) => {
    setLayout(next);
    try {
      localStorage.setItem(KEY, next);
    } catch {
      // Private windows may refuse storage; the choice still holds for this visit.
    }
  };
  return [layout, choose] as const;
}

export function LayoutSwitch({ layout, onChange }: { layout: WeekLayout; onChange: (next: WeekLayout) => void }) {
  return (
    <div role="group" aria-label="Layout" className="segmented">
      {([
        ["periods", "Periods across"],
        ["calendar", "Calendar"],
      ] as const).map(([value, label]) => (
        <button key={value} type="button" aria-pressed={layout === value} onClick={() => onChange(value)} className="segmented-option">
          {label}
        </button>
      ))}
    </div>
  );
}
